module.exports = __webpack_public_path__ + "img/36333-068.d1d414c6.jpg";